module.exports = __webpack_public_path__ + "img/incomplete_right.03ab3995.jpg";